export const TITLE = 'Experiwear - Dashboard';
export const SITE_URL = 'https://barcalink.com';
export const DESCRIPTION = 'Frictionless engagement with smart wearables';
export const EXPERIWEAR_URL = 'https://experiwear.com';
export const TEAM_NAME = 'FC Barcelona';
export const TEAM_URL = 'https://www.fcbarcelona.com/';
